"use client";

import { useUser } from "@clerk/nextjs";
import { useMutation } from "convex/react";
import { useEffect } from "react";
import { api } from "../../convex/_generated/api";

export function UserSync() {
    const { user, isLoaded } = useUser();
    const syncUser = useMutation(api.users.syncUser);

    useEffect(() => {
        if (isLoaded && user) {
            syncUser({
                clerkId: user.id,
                email: user.primaryEmailAddress?.emailAddress,
                name: user.fullName || user.username || "User",
                image: user.imageUrl,
                role: (user.publicMetadata?.role as string) || undefined,
            });
        }
    }, [isLoaded, user, syncUser]);

    return null;
}
